export default "__VITE_ASSET__D6vSLM49__"